<template>
  <div class="similar_vacancy">
    <a v-if="vacancy.company" class="similar_vacancy__logo" :href="vacancy.href">
      <img
        :src="vacancy.company.logo"
        :alt="vacancy.company.name"
        width="40"
        height="40"
      />
    </a>
    <div class="similar_vacancy__info">
      <div class="similar_vacancy__title">
        <a  :href="vacancy.href">{{ vacancy.title }}</a>
      </div>
      <div  v-if="vacancy.company" class="similar_vacancy__company" >
        <a :href="vacancy.company.href">{{ vacancy.company.name }}</a>
      </div>
      <div v-if="vacancy.city" class="similar_vacancy__city">
        <a :href="vacancy.city.href">{{vacancy.city.title}}</a>
      </div>
      <div v-if="vacancy.salary" class="similar_vacancy__salary">
        {{ vacancy.salary }}
      </div>
    </div>
  </div>
</template>

<script>
  export  default  {
    name: 'SimilarVacancy',
    
    props: {
      vacancy: {
        type: Object,
        default: ()=> ({
          company: {}
        }),
      },
    },
  }
</script>
